import { TextFieldProps } from "@mui/material";
import TextField from "@mui/material/TextField";
import { get } from "radash";
import { Controller, UseControllerProps } from "react-hook-form";
import {
  NumberFormatValues,
  PatternFormat,
  PatternFormatProps,
} from "react-number-format";

type OnValueChange = {
  valueKey?: keyof NumberFormatValues;
  formatValue?: (value: string | number) => string;
  onValueChange: (value: NumberFormatValues) => void;
};
type CustomPatternFormatType = Omit<
  PatternFormatProps,
  "customInput" | "onValueChange"
> &
  OnValueChange;

export type PatternInputProps = CustomPatternFormatType &
  TextFieldProps &
  UseControllerProps<any>;

const PatternInput = (props: PatternInputProps) => {
  const {
    name,
    control,
    valueKey = "value",
    formatValue,
    onValueChange,
    ...rest
  } = props;
  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { ref, onChange, ...restField },
        formState: state,
      }) => (
        <PatternFormat
          {...restField}
          fullWidth
          inputRef={ref}
          customInput={TextField}
          placeholder={(props.label as string) || props.placeholder}
          error={!!get(state.errors, name)}
          title={rest.label as string}
          onValueChange={(val) => {
            let value: string | number = get(val, valueKey);
            if (formatValue) {
              value = formatValue(value);
            }

            onChange(value);
            onValueChange && onValueChange(val);
          }}
          {...rest}
        />
      )}
    />
  );
};

export default PatternInput;
